<template>
  <div>
    <b-overlay
      :show="loading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <FilterCard :applied-filter-count="appliedFilterCount">
        <b-row>
          <b-col
            md="3"
          >
            <b-form-group
              label="Employee ID"
              label-for="reference_id"
            >
              <b-form-input
                id="reference_id"
                v-model="tempFilters['reference_id']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="3"
          >
            <b-form-group
              label="First Name"
              label-for="v-name"
            >
              <b-form-input
                id="v-name"
                v-model="tempFilters['first_name']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="3"
          >
            <b-form-group
              label="Email"
              label-for="v-name"
            >
              <b-form-input
                id="v-name"
                v-model="tempFilters['email']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="3"
          >
            <b-form-group
              label="NIC Number"
              label-for="nic"
            >
              <b-form-input
                id="nic"
                v-model="tempFilters['nic']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            md="3"
          >
            <b-form-group
              label="Address"
              label-for="address"
            >
              <b-form-input
                id="address"
                v-model="tempFilters['address']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="3"
          >
            <b-form-group
              label="Assigned Warehouse"
              label-for="assigned_warehouse"
            >
              <v-select
                id="assigned_warehouse"
                v-model="tempFilters['warehouse_id']"
                :options="warehouseOptions"
                :reduce="option => option.id"
                label="name"
                placeholder="Select Warehouse"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            md="3"
          >
            <b-form-group
              label="Status"
              label-for="status"
            >
              <v-select
                id="status"
                v-model="tempFilters['status']"
                :options="statusOptions"
                :reduce="option => option.value"
                label="label"
                placeholder="Select Status"
              >
                <template v-slot:option="option">
                  {{ option.label }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            v-if="staffCategorizationSettingLoaded && staffCategorizationEnabled"
            md="3"
          >
            <b-form-group
              label="Staff Type"
              label-for="staff_category_id"
            >
              <v-select
                id="staff_category_id"
                v-model="tempFilters['staff_category_id']"
                :options="staffTypeOptions"
                :reduce="option => option.id"
                label="name"
                placeholder="Select Staff Type"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Apply and Clear Filters -->
        <b-row class="mt-1">
          <b-col>
            <filter-buttons
              :filter-data="tempFilters"
              :apply-filters="applyFilters"
              :clear-filters="clearFilters"
            />
          </b-col>
        </b-row>
      </FilterCard>
      <b-card>
        <b-tabs
          ref="staffTabBar"
          v-model="selectedRoleIndex"
          card
          pills
          @input="onTabSelect"
        >
          <b-tab
            v-for="(role, index) in roles"
            :key="role.id"
          >
            <template #title>
              <span class="font-weight-bold">
                {{ role.name }}
              </span>
            </template>
            <staff-list
              v-if="staffCategorizationSettingLoaded && selectedRoleIndex === index"
              :key="`staff-list-${index}-${staffCategorizationEnabled}`"
              :role="selectedRole"
              :filters="filters"
              :staff-categorization-enabled="staffCategorizationEnabled"
            />
          </b-tab>
          <b-tab v-if="roles.length > 0">
            <template #title>
              <span class="font-weight-bold">
                All
              </span>
            </template>
            <staff-list
              v-if="staffCategorizationSettingLoaded && selectedRoleIndex === roles.length"
              ref="StaffList"
              :key="`staff-list-all-${staffCategorizationEnabled}`"
              :role="selectedRole"
              :filters="filters"
              :staff-categorization-enabled="staffCategorizationEnabled"
            />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BOverlay,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@core/mixins/filter'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'
import StaffList from './StaffList.vue'

const RoleRepository = RepositoryFactory.get('role')
const ResourceRepository = RepositoryFactory.get('resource')
const StaffSettingsRepository = RepositoryFactory.get('staffSetting')

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    BOverlay,
    StaffList,
    FilterCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    FilterButtons,
    'v-select': vSelect,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  data() {
    return {
      roles: [],
      selectedRole: null,
      selectedRoleIndex: 0,
      loading: false,
      filters: {},
      warehouseOptions: [],
      staffTypeOptions: [],
      staffCategorizationEnabled: false,
      staffCategorizationSettingLoaded: false,
      filterOn: [],
      tempFilters: {},
      statusOptions: [
        { value: 1, label: 'Active' },
        { value: 0, label: 'Inactive' },
      ],
    }
  },
  async mounted() {
    await this.readStaffCategorizationSetting()
    await this.fetchRoleList()
    // eslint-disable-next-line no-underscore-dangle
    this.__preserveTabOnRefresh('staffTabBar', 'staffTabIndex')
    await this.getWarehouseList()
    if (this.staffCategorizationEnabled) {
      await this.getStaffTypeList()
    }
    this.updateFilterCount()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.refreshStaffCategorizationSetting()
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.refreshStaffCategorizationSetting().then(() => {
      next()
    })
  },
  methods: {
    async refreshStaffCategorizationSetting() {
      await this.readStaffCategorizationSetting()
      if (this.staffCategorizationEnabled) {
        await this.getStaffTypeList()
      } else {
        this.staffTypeOptions = []
      }
    },
    async fetchRoleList() {
      try {
        this.loading = true
        const { data } = (await RoleRepository.getRoleListNoPagination())
        this.roles = data.data
        // load super admin role details
        if (this.roles.length > 0) {
          await this.loadRoleData(this.roles[0])
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async onTabSelect(index) {
      this.selectedRoleIndex = index
      if (index === this.roles.length) {
        // Load all staff members when "All" tab is clicked
        await this.loadAllStaffData()
      } else {
        const selectedRole = this.roles[index]
        await this.loadRoleData(selectedRole)
      }
    },
    async loadRoleData(role) {
      try {
        this.loading = true
        this.selectedRole = role
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async loadAllStaffData() {
      try {
        this.loading = true
        this.selectedRole = null
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async getWarehouseList() {
      try {
        this.warehouseOptions = localStorage.getItem('warehouse_list') ? JSON.parse(localStorage.getItem('warehouse_list')) : (await ResourceRepository.getWarehouseListForDropDown()).data.data
        if (!localStorage.getItem('warehouse_list')) localStorage.setItem('warehouse_list', JSON.stringify(this.warehouseOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readStaffCategorizationSetting() {
      try {
        const { data } = (await StaffSettingsRepository.getStaffSettings()).data
        this.staffCategorizationEnabled = !!data.enabled
        if (!this.staffCategorizationEnabled) {
          delete this.tempFilters.staff_category_id
          delete this.filters.staff_category_id
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      } finally {
        this.staffCategorizationSettingLoaded = true
      }
    },
    async getStaffTypeList() {
      try {
        const { data } = (await StaffSettingsRepository.getActiveStaffCategoryList()).data
        this.staffTypeOptions = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    applyFilters() {
      this.filters = { ...this.tempFilters }
      this.selectedRoleIndex = this.roles.length
      this.selectedRole = null
      // Wait for tab change, then fetch filtered data
      this.$nextTick(() => {
        if (this.$refs.staffTabBar) {
          this.$refs.staffTabBar.activateTab(this.selectedRoleIndex)
        }
      })
      this.updateFilterCount()
    },
    clearFilters() {
      this.tempFilters = {}
      this.filters = {}
      this.selectedRoleIndex = this.roles.length
      this.selectedRole = null
      this.updateFilterCount()
    },
  },
}
</script>
<style scoped>
.custom-button-color {
  background-color: #4186f5 !important;
  border-color: #4186f5 !important;
}
</style>
